// Mod_TerrainSceneries — the Set13 DB model for procedural scenery (Set13 §3.1, mirroring
// Mod_TerrainMaterials). Persists, per map (as a modifier on a MapObject):
//   - userKinds: SceneryKindDef[] — user-authored kind defs (roots, or extend/fork variants of
//     the built-ins). The kind CATALOGUE is populated from these at render time.
//   - budget: SceneryBudgetConfig — global budget/quality knobs (§3.7).
//
// ASYMMETRY vs Mod_TerrainMaterials (Set13 §3.1): there is deliberately NO `baseSceneryKindID`
// analogue to `baseRecipeID`. Every terrain fragment must have SOME material, so materials need a
// map-wide fallback. Scenery's default is NOTHING — an unpainted area has no objects on it. Any
// future "the whole map is lightly wooded" wish is a full-map `PathSceneryFeature`, not a fallback
// field.

import {SceneryKindDef} from "../../../../../Terrain/Scenery/@SceneryTypes.js";
import {SceneryBudgetConfig} from "../../../../../Terrain/Scenery/@SceneryBudgetConfig.js";

export class Mod_TerrainSceneries {
	constructor(data?: Partial<Mod_TerrainSceneries>) { Object.assign(this, data); }

	/** User-authored kind defs (roots, or extend/fork variants of the built-ins).  Loaded into the
	 *  kind catalogue at render time; the bake cache keyed by resolved structural hash makes
	 *  params-only variants free (the D10 free-variant property). */
	userKinds: SceneryKindDef[] = [];
	/** Global budget/quality knobs (§3.7). */
	budget = new SceneryBudgetConfig();
}
